// extracted by mini-css-extract-plugin
export default {"container":"Badge_container__8+604","teal":"Badge_teal__Jbh0L","orange":"Badge_orange__vxHE8","pink":"Badge_pink__EGEr1","red":"Badge_red__fjU8u"};